<template>
  <div>
    <div class="row mt-5">
      <div class="col text-center">
        <h5>Documentos / Ações para Renovação</h5>
      </div>
    </div>

    <div class="row" v-if="token.role === 'CA'">
      <div class="col">
          <form
            class="form-inline"
            v-on:submit.prevent="buscaLicencas()"
          >

            <div class="form-group col-12 col-md-12">
              <label for="filtro">Buscar</label>
              <input v-model="filtro.buscar" id="filtro" type="text" class="form-control col-12">
            </div>

           
          </form>

          <div class="alert alert-warning" role="alert" v-if="data.length === 0">
            Nenhum registro cadastrado.
          </div>

          <div id="accordion">
            <div class="card" v-for="item in filteredItems" :key="item._id">
              <div class="card-header" :id="'H' + item._id" data-toggle="collapse" :data-target="'#D' + item._id" >
                <div class="row">

                  <div class="col-1">
                    <i class="material-icons icone" :class="verificaValidade(item).classes">report_problem</i>
                  </div>

                  <div class="col-12 col-md-6">
                    {{item.documento}} /
                    {{item.tipoLicenca}} /
                    {{item.atividade}} /
                    {{item.licenca ? verificaValidade(item).diff + ' dias para vencer' : ''}}
                  </div>
                  <div class="col-12 col-md-5">
                    <a
                      href="javascript:;"
                      data-toggle="modal"
                      data-target="#protocolarModal"
                      @click="form.documento = item.documento; form._id = item._id">
                      Protocolar
                    </a>
                    <!-- /
                    <a  @click='form.arquivoToDelete = item' href="#" data-toggle="modal" data-target="#confirmModal" class="danger">
                      Remover arquivo /
                    </a> -->
                    <!-- <router-link title="Alterar" :to="`${route}/edit/${item._id}`">
                      Atualizar Arquivo
                    </router-link>/ -->
                    <!-- <router-link title="Alterar" :to="`${route}/edit/${item._id}/over`">
                      Substituir
                    </router-link> -->
                  </div>
                </div>
              </div>

              <div :id="'D'+item._id" class="collapse" data-parent="#accordion">
                <div class="card-body">
                    <table class="table table-sm">
                      <tbody>
                        <tr>
                          <td>
                            <b>{{item.documento}} - {{item.tipoLicenca}}</b>
                          </td>
                          <td>
                            <b>{{item.licenca ? 'Validade:' + formata(item.validade) : formata(item.data)}}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <a class="btn btn-sm btn-raised btn-primary btn-block" v-if="item.filename" target="_blank"
                              :href="`${api}/api/v1${route}/doc/${item.filename}?token=${jwt}&mimetype=${item.mimetype}&original=${item.originalname}`"
                            >
                            Download Licença
                            </a>
                            <span v-if="!item.filename">Nenhum</span>
                          </td>
                          <td>
                              <button
                                type="button"
                                class="btn btn-sm btn-warning btn-block btn-raised"
                                data-toggle="modal"
                                data-target="#protocolarModal"
                                @click="form.documento = item.documento;form._id = item._id">
                                + Protocolar
                              </button>
                          </td>
                        </tr>
                        <tr v-if="item.protocolado">
                          <td>Protocolo: {{item.numeroProtocolo}} <br> Data: {{formata(item.data)}}</td>
                          <td>
                            <a class="btn btn-sm btn-block btn-secondary btn-raised" v-if="item.arquivoProtocolo" target="_blank"
                              :href="`${api}/api/v1${route}/doc/${item.arquivoProtocolo.filename}?token=${jwt}&mimetype=${item.arquivoProtocolo.mimetype}&original=${item.arquivoProtocolo.originalname}`"
                            >
                            Download Protocolo
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <hr>

                    <form>
                      <div class="row">
                        <div class="col">
                          <h5>Documentos / Ações para Renovação</h5>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-3 d-none d-md-block">
                          Documento
                        </div>
                        <div class="col-md-2 d-none d-md-block">
                          Iniciado Em
                        </div>
                        <div class="col-md-2 d-none d-md-block">
                          Observação
                        </div>
                        <div class="col-md-2 d-none d-md-block">
                          Concluído Em
                        </div>
                        <div class="col-md-1 d-none d-md-block">
                          Não se aplica?
                        </div>
                        <div class="col-md-1 d-none d-md-block">
                          Anexos
                        </div>
                        <div class="col-md-1 d-none d-md-block">
                          Remover
                        </div>
                      </div>

                      <div class="row border border-secondary mb-2" v-for="(task, index) in item.tasks" :key="task.ordem">
                        <div class="col-12 d-block d-sm-none mt-2">
                          Documento
                        </div>
                        <div class="col-md-3 col-12">
                          <div class="input-group">
                            <div class="input-group-prepend mr-3 mt-2">
                              <button @click="addSub(task)" class="btn btn-raised btn-success" type="button" id="button-addon1">+</button>
                            </div>
                            <input type="text" placeholder="Documento" class="form-control" v-model="task.titulo">
                          </div>
                        </div>

                        <div class="col-12 d-block d-sm-none mt-2">
                          Iniciado em:
                        </div>

                        <div class="col-md-2 col-12">
                          <input type="date" class="form-control" v-model="task.iniciadoEm">
                        </div>

                        <div class="col-12 d-block d-sm-none mt-2">
                          Observação
                        </div>

                        <div class="col-md-2 col-12">
                          <input type="text" class="form-control" placeholder="Observação" v-model="task.obs">
                        </div>

                        <div class="col-12 d-block d-sm-none mt-2">
                          Concluído em:
                        </div>

                        <div class="col-md-2 col-12">
                          <input type="date" class="form-control" v-model="task.concluidoEm">
                        </div>

                        <div class="col-md-1 col-12 mb-sm-3 mt-3 mb-2">
                          <div class="form-check">
                            <label class="form-check-label">
                              <input type="checkbox" class="form-check-input" v-model="task.naoSeAplica">
                              N.A
                            </label>
                          </div>
                        </div>

                        <div class="col-md-1 col-12 mt-2">
                          <vue-dropzone :ref="'task' + index + item._id" :id="'task' + index + item._id" :options="dropzoneOptionsTask" v-on:vdropzone-success="(file, res) => updateDocTask(task, 'task' + index + item._id, res)"></vue-dropzone>
                        </div>

                        <div class="col-md-1 col-12 mt-2">
                          <button @click="removeTask(item, index)" class="btn btn-raised btn-danger" type="button" id="button-addon1">-</button>
                        </div>

                        <div class="col-md-12">
                          <div v-for="(anexo, idxA) in task.anexos" :key="anexo.filename">
                            <a target="_blank"
                              :href="`${api}/api/v1${route}/doc/${anexo.filename}?token=${jwt}&mimetype=${anexo.mimetype}&original=${anexo.originalname}`"
                            >
                            {{anexo.originalname}}
                            </a>
                            <span class="text-danger" @click="removeFileAnexo(task, idxA)">
                              <i class="material-icons">delete</i>
                            </span>
                          </div>
                          <hr />
                          <div class="row" v-for="(subtask, indexSub) in task.subtasks" :key="subtask.ordem">

                            <div class="col-12 d-block d-sm-none mt-2">
                              Ação
                            </div>

                            <div class="col-md-3 offset-md-1 col-sm-12">
                              <div class="input-group">
                                <input placeholder="Ação" type="text" class="form-control" v-model="subtask.titulo">
                              </div>
                            </div>

                            <div class="col-12 d-block d-sm-none mt-2">
                              Iniciado em
                            </div>

                            <div class="col-md-2 col-sm-12">
                              <input type="date" class="form-control" v-model="subtask.iniciadoEm">
                            </div>

                            <div class="col-12 d-block d-sm-none mt-2">
                              Observação
                            </div>

                            <div class="col-md-2 col-sm-12">
                              <input type="text" class="form-control" placeholder="Observação"  v-model="subtask.obs">
                            </div>

                            <div class="col-12 d-block d-sm-none mt-2">
                              Concluído em:
                            </div>

                            <div class="col-md-2 col-sm-12">
                              <input type="date" class="form-control" placeholder=""  v-model="subtask.concluidoEm">
                            </div>

                            <div class="col-md-1 col-sm-12 mb-sm-3 mt-3 mb-2">
                              <div class="form-check">
                                <label class="form-check-label">
                                  <input type="checkbox" class="form-check-input" v-model="subtask.naoSeAplica">
                                  N.A
                                </label>
                              </div>
                            </div>

                            <div class="col-md-1 col-sm-12 mb-2">
                              <button @click="removeSubtask(task, indexSub)" class="btn btn-raised btn-danger" type="button" id="button-addon1">-</button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-4">
                        <div class="col">
                          <button @click="saveTasks(item)" type="button" class="btn btn-success btn-raised">Salvar tudo</button>
                          <button @click="addItemRenov(item)" type="button" class="btn btn-raised btn-success">
                            Adicionar
                          </button>
                          <button @click="loadDefault(item)" type="button" class="btn btn-info btn-raised">
                            Carregar listagem padrão
                          </button>
                          <button @click="makeDefault(item)" type="button" class="btn btn-info btn-raised">Tornar essa listagem padrão</button>
                        </div>
                      </div>
                    </form>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>

    <!-- MODAL PROTOCOLAR -->
    <div class="modal fade" id="protocolarModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Protocolar Licença {{form.documento}}<br>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="numeroProtocolo" class="col-form-label">Número protocolo</label>
                <input type="number" v-model="form.numeroProtocolo" class="form-control" id="numeroProtocolo">
              </div>
              <div class="form-group" v-show="!form.licenca">
                <label for="data">Data</label>
                <input v-model="form.data" id="data" type="date" class="form-control">
              </div>
              <vue-dropzone ref="doc" id="doc" :options="dropzoneOptions" v-on:vdropzone-success="updateDoc"></vue-dropzone>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised mr-2" data-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-primary btn-raised" @click="adicionarProtocolo()">Protocolar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL CONFIRMAR EXCLUSAO -->
    <div class="modal fade" id="confirmModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalConfirmLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Remover arquivo
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group" v-if="form.arquivoToDelete">
                <label for="numeroProtocolo" class="col-form-label">Dados do arquivo:</label>
                {{form.arquivoToDelete.licenca ? 'Licença': 'Protocolo'}} /
                {{form.arquivoToDelete.documento}} /
                {{form.arquivoToDelete.licenca ? verificaValidade(form.arquivoToDelete).diff + ' dias para vencer' : ''}}
              </div>
            </form>
          </div>
          <div class="alert alert-danger mr12-12" role="alert">
              Tem certeza que deseja excluir?
          </div>
          <div class="modal-footer">
            <button type="button" @click="form.arquivoToDelete = {}" class="btn btn-secondary btn-raised mr-2" data-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-danger btn-raised" @click="removeFile(form.arquivoToDelete)" >Excluir</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ls from 'local-storage';
import moment from 'moment';
import vueDropzone from 'vue2-dropzone';

export default {
  components: {
    vueDropzone
  },
  computed: {
    filteredItems() {
      const search = this.filtro.buscar.toLowerCase().trim();
      if (!search) return this.data;

      return this.data.filter(item => {
        return item.documento.toLowerCase().indexOf(this.filtro.buscar.toLowerCase()) > -1
      });
    },
  },
  data() {
    return {
      data: [],
      route: '/compromissos/ambientais',
      routeO: '/compromissos/ambientais',
      routeA: '/compromissos/ambientais',
      filtro: {
        buscar: '',
        tipo: 'L',
      },
      // protocolar form
      form: {
        arquivoToDelete: {},
        numeroProtocolo: '',
        data: moment().format('YYYY-MM-DD'),
        documento: '',
        _id: '',
        arquivoProtocolo: {
          mimetype: '',
          filename: '',
          originalname: ''
        }
      },
      dropzoneOptions: this.$http.getDropzoneConfig(
        '/compromissos/ambientais/upload',
        'post',
        {
          maxFiles: 1,
          addRemoveLinks: true,
          capture: true,
          dictDefaultMessage: 'Clique ou arraste arquivos aqui para UPLOAD',
          dictRemoveFile: 'Remover'
        }
      ),
      dropzoneOptionsTask: this.$http.getDropzoneConfig(
        '/compromissos/ambientais/upload',
        'post',
        {
          maxFiles: 1,
          thumbnailWidth: 50,
          capture: true,
          dictDefaultMessage: '<i class="material-icons">attach_file</i>',
          createImageThumbnails: false,
        }
      )
    };
  },
  methods: {
    loadDefault(item) {
      if (confirm("Deseja carregar a lista padrão de tarefas? Essa ação não poderá ser desfeita.")) {
        this.$http.get(`${this.route}/gettaskspadrao`).then(response => {
          if (response.data.success) {
            item.tasks = response.data.tasks;
            this.$toasted.show('Modelo padrão carregado com sucesso!', this.$custom.success);
          } else {
            this.$toasted.show('Ocorreu um erro, tente novamente!', this.$custom.error);
          }
        });
      }
    },
    makeDefault(item) {
      if (confirm("Deseja tornar a lista atual de tarefas na lista padrão? Essa ação não poderá ser desfeita.")) {
        this.$http.post(`${this.route}/updatepadraotasks`, item).then(response => {
          if (response.data.success) {
              this.$toasted.show('Modelo padrão atualizado com sucesso!', this.$custom.success);
          } else {
            this.$toasted.show('Ocorreu um erro, tente novamente!', this.$custom.error);
          }
        });
      }
    },
    saveTasks(item) {
      this.$http.post(`${this.route}/savetasks`, item).then(response => {
        if (response.data.success) {
          this.$toasted.show('Atualizada com sucesso!', this.$custom.success);
        } else {
          this.$toasted.show('Ocorreu um erro, tente novamente!', this.$custom.error);
        }
      });
    },
    reordenar(item) {
      for (let i = 0; i < item.tasks.length; i++) {
        const task = item.tasks[i];
        task.ordem = i;
      }
    },
    reordenarSubs(task) {
      for (let i = 0; i < task.subtasks.length; i++) {
        const sub = task.subtasks[i];
        sub.ordem = i;
      }
    },
    removeFileAnexo(task, index) {
      if (confirm("Deseja remover esse anexo?")) {
        task.anexos.splice(index, 1);
      }
    },
    removeTask(item, index) {
      if (confirm("Deseja remover essa tarefa?")) {
        item.tasks.splice(index, 1);
        this.reordenar(item);
      }
    },
    removeSubtask(task, index) {
      if (confirm("Deseja remover essa sub-tarefa?")) {
        task.subtasks.splice(index, 1);
        this.reordenarSubs(task);
      }
    },
    addSub(task) {
      task.subtasks.push({
          ordem: task.subtasks.length,
          titulo: "",
          iniciadoEm: null,
          obs: "",
          concluidoEm: null,
          naoSeAplica: false,
          anexos: [],
      });
    },
    addItemRenov(item) {
      item.tasks.push({
          ordem: item.tasks.length,
          titulo: "",
          iniciadoEm: null,
          obs: "",
          concluidoEm: null,
          naoSeAplica: false,
          subtasks: [],
          anexos: [],
      });
    },
    adicionarProtocolo() {
      this.$http.post(`${this.route}/protocolar`, this.form).then(response => {
        this.form = {
          numeroProtocolo: '',
          documento: '',
          data: moment().format('YYYY-MM-DD'),
          _id: '',
          arquivoProtocolo: {
            mimetype: '',
            filename: '',
            originalname: ''
          }
        };

        this.$refs.doc.removeAllFiles(true);

        $('#protocolarModal').modal('hide');
        this.buscaLicencas();
      });
    },
    updateDoc(file, response) {
      this.form.arquivoProtocolo.mimetype = response.mimetype;
      this.form.arquivoProtocolo.filename = response.filename;
      this.form.arquivoProtocolo.originalname = response.originalname;
    },
    updateDocTask(task, ref, response) {
      task.anexos.push({
        mimetype : response.mimetype,
        filename : response.filename,
        originalname : response.originalname,
      });


      const dpRef = this.$refs[ref];
      dpRef[0].removeAllFiles();
    },
    verificaValidade(item) {
      let menor = 120;
      let maior = 150;

      const hoje = item.protocolado ? moment(item.data) : moment();
      const ate = moment(item.validade);
      const diff = ate.diff(hoje, 'days');

      if (
        item.tipoLicenca === 'SERFLOR' || 
        item.tipoLicenca === 'AA' || 
        item.tipoLicenca === 'CREA' || 
        item.tipoLicenca === 'ALVARÁ' || 
        item.tipoLicenca === 'ALVARÁ LOCALIZAÇÃO' || 
        item.tipoLicenca === 'AUTORIZAÇÃO TRANSPORTE IBAMA' || 
        item.tipoLicenca === 'ALVARÁ SANITÁRIO' || 
        item.tipoLicenca === 'OUTRO' || 
        item.tipoLicenca === 'CERTIFICADO CORPO BOMBEIROS (CVCB)' || 
        item.tipoLicenca === 'POLICIA FEDERAL'
        ) {
        min = 1;
        max = 30;
      }

      if (item.tipoLicenca === 'CTF IBAMA') {
        min = 1;
        max = 5;
      }

      if (item.tipoLicenca === 'ADAPAR') {
        min = 90;
        max = 150;
      }

      return {
        classes: {
          vermelho: item.licenca && diff < menor,
          amarelo: item.licenca && diff >= menor && diff <= maior,
          verde: item.licenca && diff > maior,
          verdeProtocolo: item.protocolado && diff >= menor
        },
        diff
      };
    },
    formata(data) {
      return moment(data).format('DD/MM/YYYY');
    },
    buscaLicencas: function() {
      this.route = this.routeA;

      if (this.filtro.tipo === 'O') {
        this.route = this.routeO;
      }

      this.$http.post(`${this.route}/listRenovacao`, { filtro: this.filtro }).then(r => {
        this.data = r.data.data;

        for (let i = 0; i < this.data.length; i++) {
          const item = this.data[i];
          for (let j = 0; j < item.tasks.length; j++) {
            const t = item.tasks[j];

            if (t.iniciadoEm) {
              t.iniciadoEm = moment(t.iniciadoEm).format('YYYY-MM-DD');
            }

            if (t.concluidoEm) {
              t.concluidoEm = moment(t.concluidoEm).format('YYYY-MM-DD');
            }

            for (let k = 0; k < t.subtasks.length; k++) {
              const s = t.subtasks[k];

              if (s.iniciadoEm) {
                s.iniciadoEm = moment(s.iniciadoEm).format('YYYY-MM-DD');
              }

              if (s.concluidoEm) {
                s.concluidoEm = moment(s.concluidoEm).format('YYYY-MM-DD');
              }
            }
          }
        }
      });
    },
    async removeFile(doc) {
      const res = await this.$http.delete(`${this.route}/${doc._id}`);
      for (let i = 0; i < this.data.length; i++) {
        const el = this.data[i];
        if (el._id === doc._id) {
          this.data.splice(i,1);
        }
      }

      $('#confirmModal').modal('hide');
    },
  },
  beforeMount() {
    this.buscaLicencas();
  }
};
</script>

<style scoped>
.id {
  font-size: 12px;
}

.card {
  cursor: pointer;
}

.dropzone, .dropzone > div {
  min-height: 0px !important;
  padding: 0px !important;
}

</style>





// WEBPACK FOOTER //
// src/components/app/compromissos/renovacao/Home.vue